import { LockSimple, LockSimpleOpen } from "@phosphor-icons/react"

import { Tooltip } from "~/components/reusable/Tooltip"

export function AdjustmentLock({ locksForecast, size }: { locksForecast: boolean; size: number }) {
  const className = `h-${size} w-${size} text-fg-subtle mr-1`
  if (locksForecast) {
    return (
      <Tooltip body="This adjustment locks the forecast for the period it applies">
        <LockSimple className={className} />
      </Tooltip>
    )
  } else {
    return (
      <Tooltip
        className="w-[350px]"
        body="This adjustment does not lock the forecast for the period it applies. Unless another locked adjustment has been added in this period, forecasts will be continuously updated."
      >
        <LockSimpleOpen className={className} />
      </Tooltip>
    )
  }
}
